import { useCallback, useState } from 'react';
import { isWithBrandStatus } from '@discovr/types';
import type { OutreachRow } from '@discovr/types';
import { hasRateToHandOff } from './handoffStates';

/** Ids the server accepted a move-to-brand for. Rows keep showing
 *  `rate_provided` in outreach until the refetch lands, so Remove must not trust that. */
export function useMovedIds() {
  const [moved, setMoved] = useState<ReadonlySet<string>>(new Set());
  const markMoved = useCallback((ids: string[]) => setMoved((previous) => new Set([...previous, ...ids])), []);
  /** Only ids whose LIVE row is known, not with the brand, and not just moved. */
  const liveRemovable = (ids: string[], knownRow: (id: string) => OutreachRow | undefined) =>
    ids.filter((id) => {
      const live = knownRow(id);
      return !!live && !isWithBrandStatus(live.status) && !(moved.has(id) && hasRateToHandOff(live));
    });
  return { markMoved, liveRemovable };
}
